export enum Assignee {
    PVCLAN = 'PVCLAN',
    EMPLOYEE = 'EMPLOYEE',
    NONE = 'NONE',
}
